import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';
import { filter, Subscription } from 'rxjs';
import {
  initDatePicker,
  surgeryScheduleFormConfig,
} from '../../config/surgery-schedule-form.config';
import { CoreService } from '../../../core/core.service';
import { SurgeryService } from '../../../../services/surgery/surgery.service';
import { Surgery } from '../../../core/models/surgery.model';

@Component({
  selector: 'app-surgery-schedule-form-dialog',
  templateUrl: './surgery-schedule-form-dialog.component.html',
  styleUrls: ['./surgery-schedule-form-dialog.component.scss'],
})
export class SurgeryScheduleFormDialogComponent {
  constructor(
    private surgeryService: SurgeryService,
    private coreService: CoreService
  ) {}

  subscriptions: Subscription[] = [];
  @ViewChild('surgeryScheduleForm', { static: false })
  surgeryScheduleForm?: EoFormComponent;

  surgery?: Surgery;
  hospitalId?: string | null;
  type?: string | null;

  visible = false;
  formConfig = [...surgeryScheduleFormConfig];

  @Output() success = new EventEmitter();

  ngOnInit(): void {
    this.subscriptions = [
      this.getSurgeryScheduleSuccessSub$(),
      this.getResurgeryScheduleSuccessSub$(),
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onSubmit($event: any) {
    if (!$event?.surgeryScheduleForm) return;

    let selectedDate = $event.surgeryScheduleForm.surgeryDateTime;
    let dateUTC = new Date(
      Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      )
    );
   
    let surgeryScheduleBind = {
      surgeryID: this.surgery?.id ?? '',
      surgeryDateTime: dateUTC ?? new Date(),
    };

    this.type == 'schedule'
      ? this.surgeryService.scheduleSurgery(surgeryScheduleBind).subscribe()
      : this.surgeryService.reScheduleSurgery(surgeryScheduleBind).subscribe();
  }

  onSubmitSuccess(): void {
    this.surgeryService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }

  showSuccessMessage(): void {
    this.coreService.showSuccess(
      this.type == 'schedule'
        ? 'Ο προγραμματισμός ολοκληρώθηκε με επιτυχία'
        : 'Ο επαναπρογραμματισμός ολοκληρώθηκε με επιτυχία'
    );
  }

  setFcValue(formControlName: string, value: any) {
    return this.surgeryScheduleForm?.setValue(
      'surgeryScheduleForm',
      formControlName,
      value
    );
  }

  getFormConfig() {
    return this.formConfig;
  }

  getHeader(): string {
    return this.type == 'schedule'
      ? 'Προγραμματισμός Χειρουργείου'
      : 'Επαναπρογραμματισμός Χειρουργείου';
  }

  initForm() {
    this.surgeryScheduleForm?.form.reset();
    this.surgeryScheduleForm?.form.enable();
    //console.log(this.surgery?.surgeryDate);
    if (this.surgery) {
      const surgeryDate = this.surgery.surgeryDate
        ? new Date(this.surgery.surgeryDate)
        : null;
      if (this.type == 'schedule' || !surgeryDate || surgeryDate < new Date()) {
        initDatePicker();
      } else {
        this.setFcValue('surgeryDateTime', surgeryDate);
      }
    }
  }

  getSurgeryScheduleSuccessSub$() {
    return this.surgeryService.surgeryScheduleCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  getResurgeryScheduleSuccessSub$() {
    return this.surgeryService.resurgeryScheduleCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  isSubmitLoading(): boolean {
    let sScheduleStatus =
      this.surgeryService.surgeryScheduleCallHandler?.status$?.getValue();
    if (sScheduleStatus === STATUS.loading) return true;

    let srScheduleStatus =
      this.surgeryService.resurgeryScheduleCallHandler?.status$?.getValue();
    if (srScheduleStatus === STATUS.loading) return true;

    return false;
  }

  show(
    surgery?: Surgery,
    hospitalId?: string | null,
    type?: string | null
  ): void {
    this.surgery = surgery;
    this.hospitalId = hospitalId;
    this.type = type;
    this.initForm();
    this.visible = true;
  }
}
